import { render } from "./PrivateClass.vue?vue&type=template&id=488e0da2"
import script from "./PrivateClass.vue?vue&type=script&lang=js"
export * from "./PrivateClass.vue?vue&type=script&lang=js"

import "./PrivateClass.vue?vue&type=style&index=0&id=488e0da2&lang=scss"
script.render = render

export default script